module.exports = __webpack_public_path__ + "img/day-trips-modal-icon.eef90d25.svg";